import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, HostBinding } from '@angular/core';
import { UIText } from '../../../text';
import { TableActionsColumnType, TableColumnType } from '../../models';
import { UITableBaseColumn } from '../table-base-column/table-base-column.component';
import { UITableBodyActionsColumn } from '../table-body-actions-column/table-body-actions-column.component';
import { UITableBodyCustomColumn } from '../table-body-custom-column/table-body-custom-column.component';
import { TablePropertyValuePipe } from '../../pipes';

@Component({
  selector: 'ui-table-body-column',
  templateUrl: './table-body-column.component.html',
  styleUrls: ['./table-body-column.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgSwitch,
    NgSwitchCase,
    UITableBodyActionsColumn,
    UITableBodyCustomColumn,
    UIText,
    TablePropertyValuePipe,
  ],
  providers: [TablePropertyValuePipe],
})
export class UITableBodyColumn extends UITableBaseColumn {
  @HostBinding('style.width') override get columnWidth() {
    return this.type === TableColumnType.Actions ? 'auto' : this.width;
  }

  onActionClicked(action: TableActionsColumnType): void {
    this.rowClicked.emit(action);
  }
}
